import { render, staticRenderFns } from "./ClientsMailsForDeliveringList.vue?vue&type=template&id=ece5c142"
import script from "./ClientsMailsForDeliveringList.vue?vue&type=script&lang=js"
export * from "./ClientsMailsForDeliveringList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports